const styles = () => ({
  button: {
    background: "#11497e",
    color: "#FFFF",
    marginTop: 25,
    minWidth: 200,
  },
  backgroundButton: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    justifyContent: "center",
  },
  textField: {
    minWidth: 200,
    marginTop: 15,
  },
  buttonAdd: {
    backgroundColor: "#11497e",
    width: "20%",
    borderRadius: 50,
    justifyContent: "center",
    marginTop: 15,
  },
});

export default styles;
